import Link from 'next/link';

import { cn } from '@/lib/utils';

// Brand form primitives shared by the lander pages and their client flows
// (LanderForm, PlayFlow). Values follow the DESIGN.md input/button specs.

export function LanderInput({ className, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      {...props}
      className={cn(
        'w-full rounded-xl border border-bnk-stroke bg-bnk-surface-3 px-4 py-3.5 text-base text-bnk-text outline-none transition-colors placeholder:text-bnk-text-tertiary focus:border-bnk-brand',
        className
      )}
    />
  );
}

interface LanderButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  href?: string;
  variant?: 'primary' | 'text';
}

// Renders a Next <Link> when given `href`, otherwise a <button> — so the same
// component covers link CTAs (/receive) and form/action buttons (/r, /play).
export function LanderButton({ href, variant = 'primary', className, children, ...rest }: LanderButtonProps) {
  const classes = cn(
    variant === 'primary' &&
      'flex h-12 w-full items-center justify-center rounded-full bg-bnk-brand px-5 font-satoshi text-base font-medium text-bnk-on-brand transition-colors hover:bg-bnk-brand-hover disabled:opacity-70',
    variant === 'text' &&
      'mx-auto py-1 font-satoshi text-sm text-bnk-text-tertiary underline underline-offset-2 transition-colors hover:text-bnk-text disabled:opacity-50',
    className
  );

  if (href) {
    return (
      <Link href={href} className={classes}>
        {children}
      </Link>
    );
  }
  return (
    <button {...rest} className={classes}>
      {children}
    </button>
  );
}
